const local = '_PROVIDER_CONTEXTO_OPERATIVO_FOLLOWAIR_'
import Vue from 'vue'

var update = false

export default {
	methods: {
		_GET_CONTEXTO_OPERATIVO: function (callback) {
			this._httpGet('/Contexto_operativo/get', function (retorno) {
				if (retorno._request && retorno._status) {
					callback(retorno.lista.length > 0 ? retorno.lista : null)
				} else {
					callback(null)
				}
			})
		},

		_providerContextoOperativoUpdate: function () {
			//console.log("update estado")
			// ESTADOS
			this._GET_CONTEXTO_OPERATIVO(function (lista) {
				if (lista != null) {
					var string = JSON.stringify(lista)
					sessionStorage.setItem(local, string)
				}
			})
		},

		_providerContextoOperativo: function (callback) {
			//console.log("update estado", update)

			if (!update) {
				update = true
				this._GET_CONTEXTO_OPERATIVO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}

			// se existir config do cliente
			if (sessionStorage.getItem(local) != null) {
				callback(JSON.parse(sessionStorage.getItem(local)))
			} else {
				this._GET_CONTEXTO_OPERATIVO(function (lista) {
					if (lista != null) {
						var string = JSON.stringify(lista)
						sessionStorage.setItem(local, string)
						callback(lista)
					} else {
						callback([])
					}
				})
			}
		}
	}
}